import React from 'react';

import { CaretButton, Header, HeaderContainer, SummaryIcon } from './styles';
import { useAccordionContext } from '../../../../hooks/ui_hooks/useAccordionContext';

export const SummaryAccordionHeader = ({ children, ...restProps }) => {
  const { expanded, setExpanded } = useAccordionContext();

  return (
    <HeaderContainer>
      <Header {...restProps}>{children}</Header>
      <CaretButton
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
        aria-label={expanded ? 'Collapse summary' : 'Expand summary'}>
        <SummaryIcon rotate={expanded ? '-180deg' : '0deg'} data-testid="SummaryAccordion:expand-icon" />
      </CaretButton>
    </HeaderContainer>
  );
};
